/*
 * Copyright (C) 2023 - present Marek Kuzora - All Rights Reserved.
 */


import Base from 'shared/client/routes/base';


export default class extends Base
{
  isRouteVisible ()
  {
    return this.isZoneLocation() && this.isUserOwner() && this.isZoneCenterAndBuildingEmpty();
  }


  isRouteDisabled ()
  {
    return false;
  }


  isRouteActivated ()
  {
    return this.isBuildingStatusConstruction();
  }


  isZoneCenterAndBuildingEmpty ()
  {
    const currentZone = this.currentLocation.getZone();

    return currentZone.getCass().isCenter() && currentZone.getBuilding() == null;
  }


  isBuildingStatusConstruction ()
  {
    const building = this.currentLocation.getZone().getBuilding();

    return building && building.getStatus().isConstruction();
  }


};
